import Promise from 'bluebird';
import $ from 'jquery';

const BaseUrl = 'AdInsight/V2/Customers({cid})/Accounts({aid})/Fluctuation';

export class FluctuationService {
  constructor({
    token,
    options,
  }) {
    this.token = token;
    this.options = options;
  }

  getUrlParam = (queryString, param) => {
    const match = RegExp(`[?&]${param}=([^&]*)`).exec(queryString);
    const queryParamValue = match && decodeURIComponent(match[1].replace(/\+/g, ' '));

    return queryParamValue ? `&${param}=${queryParamValue}` : '';
  };

  formatUrl(callType, withoutOpporCheck) {
    let url = '';
    const campaign = this.options.campaignId ? 'Campaign' : '';
    const campaignParam = this.options.campaignId ? '&campaignId={campaignId}' : '';
    const exeprimentParam = this.options.isFluctuationsExperiementEnabled ? '&$filter=true' : '';
    const urlParams = this.getUrlParam(window.location.search, 'internalVersion');
    const odataFuncPrefix = campaign ? 'Campaign' : 'Account';
    /* istanbul ignore next */
    let odataFunc = urlParams ? `Get${odataFuncPrefix}FluctuationsWithFilter` : `Get${campaign}Fluctuations`;

    if (withoutOpporCheck) {
      odataFunc = `Get${campaign}FluctuationsWithoutRecCheck`;
    }
    if (callType === 'GET') {
      url = `${BaseUrl}.${odataFunc}?userId={userId}${urlParams}${campaignParam}&granularity={granularity}&surfacingChannelId={surfacingChannelId}&startDate={startDate}&endDate={endDate}${exeprimentParam}`;
    } else {
      url = `${BaseUrl}.Post${campaign}FeedBack?userId={userId}${urlParams}${campaignParam}&uniqueId={uniqueId}&datetime={datetime}&feedbackType=Dismiss`;
    }
    let tempUrl = url.replace('{aid}', this.options.accountId)
      .replace('{userId}', this.options.userId)
      .replace('{cid}', this.options.customerId)
      .replace('{granularity}', this.options.granularity)
      .replace('{surfacingChannelId}', this.options.surfacingChannelId)
      .replace('{startDate}', this.options.startDate)
      .replace('{endDate}', this.options.endDate)
      .replace('{uniqueId}', this.options.uniqueId)
      .replace('{datetime}', this.options.datetime);

    if (this.options.campaignId) {
      tempUrl = tempUrl.replace('{campaignId}', this.options.campaignId);
    }
    const host = this.options.host || `${window.location.origin}/ODataApi/`;
    return `${host}${tempUrl}`;
  }

  /**
   * Gets localized list of granularities for the current daterange.
   * @param {string} callType - one of 'GET' or 'POST'
   * @param {boolean}  withoutOpporCheck - one of 'account' or 'campaign'
   * @returns {object} option object to be used in ajax call
  */
  generateRequestOption(callType, withoutOpporCheck = false) {
    const option = {
      contentType: 'application/json',
      type: callType,
      headers: {
        authorization: `CCMTSmallToken ${this.token}`,
      },
      cache: callType === 'POST', // Disable cache when GET fluctuations
    };

    option.url = this.formatUrl(callType, withoutOpporCheck);

    return option;
  }

  findAll({
    withoutOpporCheck = false,
  } = {}) {
    const option = this.generateRequestOption('GET', withoutOpporCheck);

    return new Promise((resolve, reject) => {
      /* istanbul ignore next */
      $.ajax(option).then((rawData) => {
        /* istanbul ignore next */
        resolve(rawData.value);
      }, reject);
    });
  }

  postFeedback() {
    const option = this.generateRequestOption('POST');

    return new Promise((resolve, reject) => {
      /* istanbul ignore next */
      $.ajax(option).then(() => {
        /* istanbul ignore next */
        resolve();
      }, reject);
    });
  }
}
